(function () {
  function setStatus(el, msg, type) {
    if (!el) return;
    el.textContent = msg || "";
    el.className = "ankauf-status" + (type ? (" " + type) : "");
  }

  async function uploadToCloudinary(file, cloudName, uploadPreset) {
    const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", uploadPreset);

    const res = await fetch(url, { method: "POST", body: fd });

    let data = null;
    try { data = await res.json(); } catch (e) {}

    if (!res.ok) {
      const msg = (data && data.error && data.error.message)
        ? data.error.message
        : ("Upload fehlgeschlagen (HTTP " + res.status + ")");
      throw new Error(msg);
    }

    if (!data || !data.secure_url) throw new Error("Cloudinary hat keine URL zurückgegeben.");
    return data.secure_url;
  }

  function init(container) {
    if (!container || container.dataset.ankaufBound === "1") return;

    const cloudName = container.getAttribute("data-cloud-name");
    const uploadPreset = container.getAttribute("data-upload-preset");

    const form = container.querySelector("form");
    if (!form) return;

    const statusEl = container.querySelector("#uploadStatus") || document.getElementById("uploadStatus");
    const submitBtn = container.querySelector("#submitBtn") || form.querySelector('button[type="submit"]');

    const fileInputs = [
      container.querySelector("#img1"),
      container.querySelector("#img2"),
      container.querySelector("#img3")
    ];

    const hiddenInputs = [
      container.querySelector("#hiddenImg1"),
      container.querySelector("#hiddenImg2"),
      container.querySelector("#hiddenImg3")
    ];

    // ✅ Sichtbarer Beweis, dass das Script läuft:
    setStatus(statusEl, "Uploader bereit.", "ok");

    container.dataset.ankaufBound = "1";

    form.addEventListener("submit", async function (e) {
      if (hiddenInputs.every(h => h && h.value)) return;

      e.preventDefault();

      if (!cloudName || !uploadPreset) {
        setStatus(statusEl, "Cloudinary-Konfiguration fehlt (cloud name / preset).", "error");
        return;
      }

      const files = fileInputs.map(i => i && i.files && i.files[0]).filter(Boolean);
      if (files.length !== 3) {
        setStatus(statusEl, "Bitte lade genau 3 Bilder hoch.", "error");
        return;
      }

      submitBtn && (submitBtn.disabled = true);
      setStatus(statusEl, "Bilder werden hochgeladen…");

      try {
        for (let i = 0; i < 3; i++) {
          setStatus(statusEl, `Upload Bild ${i + 1} von 3…`);
          const url = await uploadToCloudinary(files[i], cloudName, uploadPreset);
          hiddenInputs[i].value = url;
        }

        setStatus(statusEl, "Upload abgeschlossen. Anfrage wird gesendet…", "ok");
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();

      } catch (err) {
        hiddenInputs.forEach(h => h && (h.value = ""));
        setStatus(statusEl, "Fehler: " + (err?.message || "Unbekannt"), "error");
        submitBtn && (submitBtn.disabled = false);
      }
    }, { passive: false });
  }

  function initAll() {
    document.querySelectorAll("[data-ankauf-cloudinary]").forEach(init);
  }

  // Normaler Seitenaufruf
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify Theme-Editor: Sections werden dynamisch nachgeladen
  document.addEventListener("shopify:section:load", initAll);
})();